import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Public portal-level settings — currently just controls whether the 3D
// Printing side must show the 21+ age gate (admin can force it if listings
// start including NSFW pieces). Fetched lazily and cached in memory so every
// page inside /prints doesn't re-hit the endpoint on every mount.
let _cache = null;
let _pending = null;

async function fetchPortalSettings() {
  if (_cache) return _cache;
  if (_pending) return _pending;
  _pending = (async () => {
    try {
      const r = await api.get("/settings/portal");
      _cache = r.data || {};
    } catch (_) {
      _cache = {}; // fall back to defaults; do not gate visitors on transient errors
    } finally {
      _pending = null;
    }
    return _cache;
  })();
  return _pending;
}

export function usePortalSettings() {
  const [settings, setSettings] = useState(_cache);
  useEffect(() => {
    let alive = true;
    fetchPortalSettings().then((s) => { if (alive) setSettings(s); });
    return () => { alive = false; };
  }, []);
  return settings || {};
}

// Admin uses this after toggling — busts the cache so the next fetch is fresh.
export function invalidatePortalSettings() {
  _cache = null;
  _pending = null;
}
